import React from 'react'

import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { BasicInfoScreenValidationResult } from '../../../../../../../@types/validation-types'
import { Stepper } from '../../../../../../common/inputs/stepper/Stepper'
import LabelWithTooltip from '../common/LabelWithTooltip'
import RoomPopoverContent from './RoomPopoverContent'
import './RoomField.css'

export interface RoomFieldProps extends FieldProps<BasicInfoScreenValidationResult> {
  labelKey?: string
  showLabelWithTooltip?: boolean
}

const RoomField: React.FC<RoomFieldProps> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
  wrapperClassName = 'grid-item one-half desk-padding-left-m lap-padding-left-m palm-padding-right',
  labelKey,
  showLabelWithTooltip = false,
}) => {
  const { t } = useTranslation()

  const defaultLabelKey = 'wizard.screen.basicInfo.room.label'
  const currentLabelKey = labelKey || defaultLabelKey

  const labelWithTooltip = (
    <LabelWithTooltip
      inputId='room'
      labelText={t(currentLabelKey)}
      tooltipContent={<RoomPopoverContent />}
      showMandatory={true}
      containerClassName='margin-bottom-xs'
    />
  )

  return (
    <div className={wrapperClassName}>
      {showLabelWithTooltip && labelWithTooltip}
      <Stepper
        id='room'
        propertyName='room'
        placeholder={t('wizard.screen.basicInfo.room.placeholder')}
        label={showLabelWithTooltip ? '' : currentLabelKey}
        input={insertionData.room}
        type='tel'
        numericOnly
        maxLength={4}
        max={999}
        step={0.5}
        errors={validationMessages!.room ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
        hideMandatorySign={showLabelWithTooltip}
        dataHeyimmoContext='details_number_of_rooms'
      />
    </div>
  )
}

export default RoomField
